import styled from 'styled-components';

import { Icons } from 'components';
import { useSchool } from 'features/school';

const WhatsappLabel = styled.div`
  white-space: nowrap;
  padding-left: 20px;
  color: white;
  font-size: 18px;
`;

const WhatsappWrapper = styled.a`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  background: #01e676;
  position: fixed;
  z-index: 1000;
  bottom: 30px;
  right: 30px;
  border-radius: 22px;
  transition: width 0.3s ease-in-out;
  overflow: hidden;

  width: 44px;
  height: 44px;

  &:hover {
    width: 290px;
  }
`;

const WhatsappIconWrapper = styled.div`
  position: relative;
  width: 44px;
  height: 44px;
  position: absolute;
  right: 0;
  background: #01e676;
  border-radius: 22px;
`;

const WhatsappIcon = styled(Icons)`
  width: 24px;
  color: white;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const Whatsapp = () => {
  const { schoolMelver, schoolUuid } = useSchool();

  const isBenndorf = schoolUuid === 'cfaf550b-037d-45b2-9f84-979fb01185d4';
  const isMeuPlanoCrypto = schoolUuid === '20b929ad-c773-46e2-93de-991988587835';
  const isIlimitz = schoolUuid === 'fc57d3b2-f88e-40b2-851f-73f8a25fb76b';
  const is3xperiencia = schoolUuid === 'fe8e4d2e-30cd-41d8-8e32-ad3bcd79ad9a';
  const schoolDVInvest = schoolUuid === '519a0647-e8b4-48bc-9158-d5488d8036bd';

  let whatsapp = '';

  if (schoolMelver) {
    whatsapp = '5548991067463';
  } else if (isBenndorf) {
    whatsapp = '5511983380070';
  } else if (isMeuPlanoCrypto) {
    whatsapp = '41992579094';
  } else if (isIlimitz) {
    whatsapp = '5562983267200';
  } else if (is3xperiencia) {
    whatsapp = '5511958549601';
  } else if (schoolDVInvest) {
    whatsapp = '551148583035';
  }

  return !!whatsapp ? (
    <WhatsappWrapper href={`https://api.whatsapp.com/send?phone=${whatsapp}`} target="_blank">
      <WhatsappLabel>Fale conosco via WhatsApp</WhatsappLabel>
      <WhatsappIconWrapper>
        <WhatsappIcon icon="whatsapp" />
      </WhatsappIconWrapper>
    </WhatsappWrapper>
  ) : (
    <></>
  );
};

export default Whatsapp;
